// extracted by mini-css-extract-plugin
module.exports = {"button":"play_button__fjqOO"};